import React from 'react';
import styles from './AudioRepeatCheckbox.module.scss';

type Props = {
  // デフォルトのチェック値
  defaultChecked: boolean;
  // チェックの変更処理
  toggleChecked: () => void;
};

const AudioRepeatCheckbox = React.memo<Props>((props) => (
  <label className={styles['repeat-btn']}>
    <input
      className={styles['repeat-ckb']}
      type="checkbox"
      defaultChecked={props.defaultChecked}
      onClick={props.toggleChecked}
    />
    <span className={styles['repeat-ckb-icon']} />
  </label>
));

export default AudioRepeatCheckbox;
